import React, { useState, useEffect } from 'react';
import Logo from './Logo';

const LINKS = [
  ['#features',  'Features'],
  ['#countries', 'Countries'],
  ['#pricing',   'Pricing'],
  ['#about',     'About'],
  ['#contact',   'Contact'],
];

export default function Nav() {
  const [scrolled,   setScrolled]   = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close drawer on route change (hash click)
  const close = () => setDrawerOpen(false);

  return (
    <>
      {/* ── Desktop / base nav ── */}
      <nav className="nav" style={{ background: scrolled ? 'rgba(12,18,32,.98)' : 'rgba(12,18,32,.92)' }}>
        <div className="nav-inner">
          <a href="/" className="nav-brand" aria-label="Quoteology home">
            <Logo size={34}/>
            <span className="nav-wordmark">Quoteology</span>
          </a>

          {/* Desktop links */}
          <ul className="nav-links-desktop">
            {LINKS.map(([href, label]) => (
              <li key={href}><a href={href}>{label}</a></li>
            ))}
            <li>
              <a href="https://app.quoteology.net" className="btn-nav">
                Platform login
              </a>
            </li>
          </ul>

          {/* Burger — mobile only */}
          <button
            className="nav-burger"
            aria-label={drawerOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={drawerOpen}
            onClick={() => setDrawerOpen(o => !o)}
          >
            <span style={{ transform: drawerOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none' }}/>
            <span style={{ opacity: drawerOpen ? 0 : 1 }}/>
            <span style={{ transform: drawerOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none' }}/>
          </button>
        </div>
      </nav>

      {/* ── Mobile drawer — conditionally rendered, full screen overlay ── */}
      {drawerOpen && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 999,
        }}>
          {/* Backdrop */}
          <div
            onClick={close}
            style={{
              position: 'absolute', inset: 0,
              background: 'rgba(0,0,0,.6)',
              backdropFilter: 'blur(2px)',
            }}
          />
          {/* Drawer panel — drops from top, covers ~half screen */}
          <div style={{
            position: 'absolute',
            top: 0, left: 0, right: 0,
            maxHeight: '55vh',
            background: '#0C1220',
            borderBottom: '1px solid rgba(255,255,255,.1)',
            padding: '80px 24px 28px',
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            zIndex: 1000,
            overflowY: 'auto',
          }}>
            {LINKS.map(([href, label]) => (
              <a
                key={href}
                href={href}
                onClick={close}
                style={{
                  display: 'block',
                  padding: '14px 16px',
                  fontSize: 18,
                  fontWeight: 500,
                  color: 'rgba(255,255,255,.85)',
                  borderRadius: 8,
                  textDecoration: 'none',
                  transition: 'background .12s',
                }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,.07)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                {label}
              </a>
            ))}
            <a
              href="https://app.quoteology.net"
              onClick={close}
              style={{
                display: 'block',
                marginTop: 16,
                padding: '14px 16px',
                fontSize: 16,
                fontWeight: 600,
                color: '#fff',
                background: '#0EA5E9',
                borderRadius: 8,
                textAlign: 'center',
                textDecoration: 'none',
              }}
            >
              Platform login
            </a>
          </div>
        </div>
      )}
    </>
  );
}